"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var parsedLabel = function (_a) {
    var defaultId = _a.defaultId, label = _a.label;
    if (Array.isArray(label)) {
        var labelText = label[0], labelLongerText = label[1];
        return (react_1["default"].createElement("label", { htmlFor: defaultId },
            react_1["default"].createElement("span", null, labelText),
            react_1["default"].createElement("span", null, labelLongerText)));
    }
    return (react_1["default"].createElement("label", { htmlFor: defaultId },
        react_1["default"].createElement("span", null, label)));
};
exports["default"] = parsedLabel;
